// pkg47 — auto sources extended: today's day/month/year/date + firm signer's name — delivered 2026-07-05
// pkg43 — field-ownership helpers shared by the wizard, client module page, review page, and prepare page. Mirrors the backend logic in routes/firmModules.js exactly — delivered 2026-07-04

// schema_json.completed_by: 'attorney' | 'client' | 'both' — default 'client'
// (every pre-pkg43 module reads as client-completed, changing nothing).
export function moduleCompletedBy(schema) {
  const v = schema && schema.completed_by;
  return v === 'attorney' || v === 'both' ? v : 'client';
}

// field.filled_by: 'client' | 'attorney' | 'auto' — unset falls back to the
// module default. 'auto' fields are filled from the client record at
// generation time and shown to nobody.
export function fieldOwner(field, completedBy) {
  const fb = field && field.filled_by;
  if (fb === 'attorney' || fb === 'client' || fb === 'auto') return fb;
  return completedBy === 'attorney' ? 'attorney' : 'client';
}

// Does the schema contain at least one field the given owner completes?
export function hasOwnedFields(schema, owner) {
  const cb = moduleCompletedBy(schema);
  for (const sec of (schema?.sections || [])) {
    for (const f of (sec.fields || [])) {
      if (fieldOwner(f, cb) === owner) return true;
    }
  }
  return false;
}

export const AUTO_RECORD_KEYS = [
  { value: 'client_name',  label: "Client's full name" },
  { value: 'client_email', label: "Client's email address" },
  { value: 'client_phone', label: "Client's phone number" },
  // pkg47 — generation-time date parts for execution-date lines
  { value: 'current_day',   label: "Today's day (e.g. 5th)" },
  { value: 'current_month', label: "Today's month (e.g. July)" },
  { value: 'current_year',  label: "Today's year (e.g. 2026)" },
  { value: 'current_date',  label: "Today's full date (e.g. July 5, 2026)" },
  // pkg47 — fills from the Sign-for-the-firm act; blank until signed
  { value: 'attorney_signature_name', label: "Firm signer's name (after Sign for the firm)" },
];
